const toMin = (t) => {
  const m = /(\d+):(\d+)(am|pm)/i.exec(t || "");
  if (!m) return null;
  let h = Number(m[1]) % 12;
  if (m[3].toLowerCase() === "pm") h += 12;
  return h * 60 + Number(m[2]);
};

const DINNER = 18 * 60 + 30;

// Where does dinner fit around an evening event? Returns { label, millie } or null.
export function eatTiming(ev) {
  const s = toMin(ev?.start), e = toMin(ev?.end);
  if (s == null || e == null) return null;
  if (e <= DINNER) return { label: `Eat after ${ev.title}`, sub: `done by ${ev.end}`, millie: `eat after, a quick one when you're home!` };
  if (s >= DINNER) return { label: `Eat before ${ev.title}`, sub: `out the door ${ev.start}`, millie: `eat before you head out — nice and quick!` };
  if (s - 16 * 60 >= 45) return { label: `Eat early, before ${ev.title}`, sub: `kicks off ${ev.start}`, millie: `early tea tonight, then off you go!` };
  return { label: `Eat late, after ${ev.title}`, sub: `wraps up ${ev.end}`, millie: `late tea tonight — something fast when you're back.` };
}
